<template>
    <div>
      <div class="fu">
        <h1 class="title">设置可换比教程</h1>
        <p class="test">
           什么是可换比？
        </p>
        <p class="test">
           可换比的意思就是：电池充电达到了设置的那个比值，骑手就可以把那个电池借出去。<br>  
        </p>
        <p class="test">
            如果达到了可换比，还没骑手借走电池，电池也会继续充电。直到充到满电。<br>  
        </p>
        
        <p class="test">
           可换比设置方法如下：
        </p>
        
        <img src="../../../assets/LendRatio1.png" style="width: 65vw;height: 60vh;">
        <img src="../../../assets/LendRatio2.png" style="width: 65vw;height: 60vh;">
        <img src="../../../assets/LendRatio3.png" style="width: 65vw;height: 60vh;">
       </div>
    </div>
  </template>
  
  <script>
    export default {
            name:"LendRatio"
    }
  </script>
  
  <style scoped>
  @media(max-width:768px) {
    .test{
    font-size: 5vw;
    border-left: 5px solid #42b983;
    background-color: #f3f5f7;
    padding-left:1vw;
    font-family: Helvetica Neue, SimSun, 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
  }
    .title{
    font-size: 6vw;
    color: #2c3e50;
  }
    .antenae{
    width: 90vw;
    height: 45vh;
    }
    .fu{
      width:100%;
      margin-left: 0px;
    }
  }
  
  @media (min-width: 768px){
    .test{
    font-size: 20px;
    border-left: 5px solid #42b983;
    background-color: #f3f5f7;
    padding-left:1vw;
    font-family: Helvetica Neue, SimSun, 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
  }
  .title{
    font-size: 30px;
    color: #2c3e50;
  }
  .fu{
  margin-left: 13vw;
  margin-right: 7vw;
  }
  .antenae{
    width: 50vw;
    height: 60vh;
  }
  }
  </style>